import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { apolloClient } from "../../constants/apolloClient";
import { GetFeatureFlagByNameKeyQueryDocument } from "./graphql/GetFeatureFlagByNameKeyQuery.v5.generated";
function fetchV5FeatureFlag(_x) {
  return _fetchV5FeatureFlag.apply(this, arguments);
}
function _fetchV5FeatureFlag() {
  _fetchV5FeatureFlag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var _data$feature_flag;
    var flagKey, organizationId, noCache, _yield$apolloClient$q, error, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          flagKey = _ref.flagKey, organizationId = _ref.organizationId, noCache = _ref.noCache;
          _context.next = 3;
          return apolloClient.query({
            query: GetFeatureFlagByNameKeyQueryDocument,
            fetchPolicy: noCache ? 'no-cache' : 'cache-first',
            variables: {
              name_key: flagKey,
              organization_id: organizationId
            },
            context: {
              clientName: 'v5'
            }
          });
        case 3:
          _yield$apolloClient$q = _context.sent;
          error = _yield$apolloClient$q.error;
          data = _yield$apolloClient$q.data;
          return _context.abrupt("return", {
            error: error,
            flagKey: flagKey,
            apiVersion: 'V5',
            flagValue: Boolean(data === null || data === void 0 ? void 0 : (_data$feature_flag = data.feature_flag) === null || _data$feature_flag === void 0 ? void 0 : _data$feature_flag.value)
          });
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchV5FeatureFlag.apply(this, arguments);
}
export default fetchV5FeatureFlag;